import React from 'react';
import cn from 'classnames';

import IMG_LOADING from 'assets/images/pos/deposit-waiting.png';
import AnimatedCircle from 'components/generic/AnimatedCircle.component';
import SM from 'components/sidebar/appointment/wizard/Wizard.module.scss';
import DEPOSIT_ACTION from 'constants/payment/depositAction.const';
import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';

const L = logger('DepositLoadingPanel'); // eslint-disable-line no-unused-vars

const LOADING_STATUSES = Object.freeze({
  [DEPOSIT_ACTION.bankDeposit]: 'Keeping deposit...',
  [DEPOSIT_ACTION.bankCharges]: 'Holding deposit...',
  [DEPOSIT_ACTION.refund]: 'Refunding deposit...',
  [DEPOSIT_ACTION.keep]: '', // ? why is empty
});

const DepositLoadingPanel = ({ tag: tagFromProps, depositAction }) => {
  const { isDarkMode } = useTheme();
  const tag = fromAnyToTrimmed(tagFromProps);

  const message = LOADING_STATUSES[depositAction];

  // deliberately ignored deposit action
  if ('' === message || null === message || void 1 === message) {
    return <div data-bem="DepositLoadingPanel--empty" data-tag={tag} data-deposit-action={depositAction}></div>;
  }

  if (!message) {
    L.warn('()', 'Unhandled depositAction:', depositAction, 'in LOADING_STATUSES:', LOADING_STATUSES, 'returning null');
    return <div data-bem="DepositLoadingPanel--missing" data-tag={tag} data-deposit-action={depositAction}></div>;
  }

  return (
    <div
      data-bem="DepositLoadingPanel"
      data-tag={tag}
      data-deposit-action={depositAction}
      className={cn({
        [SM.component]: true,
        [SM.dark]: isDarkMode,
        [SM.imageLoadingOverlay]: true,
      })}
    >
      <div data-bem="DepositLoadingPanel__loading-container" data-tag={tag} className={SM.imageLoadingContainer}>
        <div data-bem="DepositLoadingPanel__animation-container" data-tag={tag} className={SM.imageLoadingSpin}>
          <AnimatedCircle>
            <img
              data-bem="DepositLoadingPanel__image"
              data-tag={tag}
              src={IMG_LOADING}
              alt={message}
              className={SM.imageLoading}
            />
          </AnimatedCircle>
        </div>
        <span data-bem="DepositLoadingPanel__message" data-tag={tag} className={SM.imageLoadingText}>
          {message}
        </span>
      </div>
    </div>
  );
};

export default DepositLoadingPanel;
